export default __webpack_public_path__ + "static/media/splashRight.4412ed0a.svg";